import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgArrowRight(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.9824 17.2502L18.2324 24.0002L20.0002 25.768L28.8841 16.8841C29.1185 16.6497 29.2502 16.3317 29.2502 16.0002C29.2502 15.6687 29.1185 15.3507 28.8841 15.1163L20.0002 6.23242L18.2324 8.00019L24.9825 14.7502L2.75 14.7502V17.2502L24.9824 17.2502Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
